import { render, staticRenderFns } from "./audit-role.vue?vue&type=template&id=6e575bd6&scoped=true"
import script from "./audit-role.vue?vue&type=script&lang=js"
export * from "./audit-role.vue?vue&type=script&lang=js"
import style0 from "./audit-role.vue?vue&type=style&index=0&id=6e575bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e575bd6",
  null
  
)

export default component.exports